import ButtonBase, { ButtonBaseProps } from "@mui/material/ButtonBase";

interface LowercaseButtonProps
  extends Omit<ButtonBaseProps, "sx" | "children" | "color"> {
  children?: React.ReactNode;
  color: "primary" | "secondary";
}

const LowercaseButton: React.FC<LowercaseButtonProps> = ({
  children,
  color,
  ...rest
}) => {
  const background =
    color === "primary" ? "#E3E1FF" : "rgba(248, 48, 58, 0.20)";
  const htmlColor = color === "primary" ? "#755FFA" : "#F8303A";

  return (
    <ButtonBase
      {...rest}
      sx={{
        background: background,
        borderRadius: "20px",
        color: htmlColor,
        fontFamily: "Lato",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 700,
        height: "32px",
        lineHeight: "normal",
        padding: "10px",
        textDecoration: "none",
        width: "96px",
      }}
    >
      {children}
    </ButtonBase>
  );
};

export default LowercaseButton;
